<woa-field [label]="'woa.label.payment.cardNumber'" [required]="true" [disabled]="disabled()"
           [validationMessage]="cardNumberError()">
    <div #cardNumber class="stripe-input"></div>
</woa-field>
<woa-field-pair>
    <woa-field [label]="'woa.label.payment.cardExpiry'" [required]="true" [disabled]="disabled()"
               [validationMessage]="cardExpiryError()">
        <div #cardExpiry class="stripe-input"></div>
    </woa-field>
    <woa-field [label]="'woa.label.payment.cardCvc'" [required]="true" [disabled]="disabled()"
               [validationMessage]="cardCvcError()">
        <div #cardCvc class="stripe-input"></div>
    </woa-field>
</woa-field-pair>
@if (showSavePaymentDetailsOption()) {
    <woa-selector-control [label]="'woa.label.payment.saveCardDetails'"
                          [(selected)]="savePaymentDetails"></woa-selector-control>
}
